export default "__VITE_ASSET__v3Se7j9H__"